import { useState, useEffect } from 'react'

export const useFetchAllCollateral = ({ marvarApi, dispatch, onLogout }) => {
    const [collateral, setCollateral] = useState([])

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(0)
    const executeFetchCollateral = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-all-collateral`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {

                // Setea en el estado del formulario los datos del registro
                setCollateral(resp.data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute])

    return { collateral, executeFetchCollateral }
}

export const useFetchInfoCollateral = ({ marvarApi, dispatch, onLogout, Forms }) => {

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormCollateral: { setFormState } } = Forms

    const [paramsToSearch, setParamsToSearch] = useState({})

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(0)
    const executeFetchInfoCollateral = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-collateral-ID/${paramsToSearch.idcollateral}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.idcollateral > 0) {
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idvehicledeposit: data.idvehicledeposit || 0,
                        marca: data.marca || '',
                        modelo: data.modelo || '',
                        linea: data.linea || '',
                        color: data.color || '',
                        matricula: data.matricula || '',
                        chasis: data.chasis || '',
                        clean_valor: data.valor || '',
                        valor: numberFormatter.format(data.valor) || '',
                        title: data.title || '',
                        type_collateral: data.type_collateral || '',
                        estate: data.estate || '',
                        folio: data.folio || '',
                        department: data.department || '',
                        book: data.book || '',
                        description: data.description || '',
                    }))
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetchInfoCollateral }
}

export const useFetchCollateralImages = ({ marvarApi, dispatch, onLogout, Forms }) => {
    const { FormCollateral: { formState, setFormState } } = Forms;

    const [execute, setExecute] = useState(0);

    const executeFetchCollateralImages = () => {
        setExecute((prev) => prev + 1);
    };

    const fetchData = async () => {
        const token = localStorage.getItem("token");
        if (!token) return dispatch(onLogout());

        const response = await marvarApi.get(
            `/credits/collateral/${formState.idcollateral}/images`
        );

        return response.data;
    };

    useEffect(() => {
        if (formState.idcollateral > 0) {
            fetchData()
                .then((resp) => {
                    // resp.data -> arreglo de imágenes (según tu ejemplo)
                    setFormState((prev) => ({
                        ...prev,
                        images: resp.data || []
                    }));
                })
                .catch((e) => {
                    console.error(e, "________ERROR FETCH IMAGES");
                });
        }
    }, [formState.idcollateral, execute]);

    return { executeFetchCollateralImages };
};







